// Copyright © 2017-2019  SDG Systems, LLC. All rights reserved.
// This file may not be used in any form without the express written permission of SDG Systems, LLC.

<template>
  <v-container fluid grid-list-md>
    <v-row wrap>
      <v-col cols="12" justify-center>
        <item-list
        allowAdd
        allowDelete
        :endpoint="endpoint + 'sites'"
        editRoute="siteEdit"
        :headers="headers"
        id="_id"
        name="Site"
        permissions="sites"
        :searchBarText="searchBarText"
        ></item-list>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import moment from 'moment'

import {ENDPOINT} from '@/shared/constants'
import ItemList from '@sdgsystems/vue-common/components/ItemList.vue'

export default {
  components: {
    ItemList
  },

  props: {
    searchBarText: String
  },

  data () {
    return {
      endpoint: ENDPOINT,
      headers: [
        {
          text: 'Name',
          value: 'name',
          sortable: true
        },
        {
          text: 'Description',
          value: 'description',
          sortable: true
        },
        {
          text: 'Start Date',
          value: 'startdate',
          function: this.formatTime,
          sortable: true
        }
      ]
    }
  },

  methods: {
    formatTime: function (item) {
      var stuff = moment(String(item.startDate)).format('MM/DD/YYYY')
      return stuff
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Sites.vue